<div class="image-viewer__background">
  <img class="image-viewer__image" [src]="imagePath" />
</div>